@if (message$ | async; as message) {
	@if (message.show) {
		<p id="notification" #outlet>
			<alert [type]="message.type" [dismissible]="true" (onClose)="close()">
				<div [innerHTML]="message.message | safe: message.safeType"></div>
			</alert>
		</p>
	}
}
